<template>
  <div
    id="calendar-sidebar"
    class="pa-6"
  >
    <!--<v-row
      no-gutters
      class="black--text subtitle-2 font-weight-medium mb-5"
      align="center"
    >
      <v-col>
        {{ $t('schedule_card_title.this_week') }}
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col
        v-for="d in days"
        :key="d.date"
        class="text-center pr-1"
      >
        <div
          style="border: 1px solid rgba(79,79,79,0.5)"
          class="rounded-sm black--text py-2 fill-height"
        >
          <div
            style="opacity: 0.2; font-size: 12px"
            class="font-weight-bold"
          >
            {{ d.day }}
          </div>
          <div
            class="caption mt-1"
            style="opacity: 0.8"
          >
            {{ d.date }}
          </div>
          <div>
            <v-avatar
              v-for="event in d.events"
              :key="event.id"
              size="8px"
              :color="eventTypes[event.event_type].color"
              class="mr-1"
            />
          </div>
        </div>
      </v-col>
    </v-row> -->

    <div class="black--text text-h6 font-weight-medium mb-5">
      {{ $t('schedule_card.upcoming_events') }}
    </div>

    <div
      v-for="day in upcoming"
      :key="'upcoming_'+day.date"
      class="mb-4"
    >
      <div
        class="font-weight-bold blue--text mb-1"
        :class="{'blue--text': dayjs(day.date).isSame($dayjs(), 'date'), 'grey--text': !dayjs(day.date).isSame($dayjs(), 'date')}"
      >
        <span class="font-weight-regular">{{ dayjs(day.date).format('ddd, ll') }}</span>
        <span
          v-if="dayjs(day.date).isSame($dayjs(), 'date')"
          class="mr-2"
        > ({{ $t('schedule_card.today') }})</span>
        <span
          v-else-if="dayjs(day.date).isTomorrow($dayjs())"
          class="mr-2"
        > ({{ $t('schedule_card.tomorrow') }})</span>
      </div>

      <div v-if="day.events.length > 0">
        <v-row
          v-for="event in day.events"
          :key="'upcoming_event_'+event.id"
          no-gutters
          class="mb-2"
        >
          <v-col style="flex: 0 0 30px">
            <v-avatar
              :color="eventTypes[event.event_type].color"
              size="10px"
              class="mt-n3"
            />
          </v-col>
          <v-col
            :class="{'black--text': dayjs().isBefore(event.end_at), 'grey--text': dayjs().isAfter(event.end_at)}"
            class="body-1"
          >
            <div
              style="opacity: 0.6"
              class="mb-1"
            >
              <span>{{ $dayjs(event.start_at).format('HH:mm') }}</span>
              <span
                v-if="event.end_at"
                class="px-1"
              >-</span>
              <span v-if="event.end_at">{{ $dayjs(event.end_at).format('HH:mm') }}</span>
            </div>
            <div>{{ event.title }}</div>
          </v-col>
        </v-row>
      </div>
      <div
        v-else
        class="black--text opacity--03 caption"
      >
        {{ $t('schedule_card.no_events_scheduled') }}
      </div>
    </div>

    <!--    <v-row-->
    <!--      no-gutters-->
    <!--      class="mt-3"-->
    <!--    >-->
    <!--      <v-col style="flex: 0 0 30px">-->
    <!--        <v-avatar-->
    <!--          color="orange"-->
    <!--          size="10px"-->
    <!--          class="mt-n3"-->
    <!--        />-->
    <!--      </v-col>-->
    <!--      <v-col class="white&#45;&#45;text body-1">-->
    <!--        <div-->
    <!--          style="opacity: 0.6"-->
    <!--          class="mb-1"-->
    <!--        >-->
    <!--          12:00 - 14:00-->
    <!--        </div>-->
    <!--        <div>Testing session at Field #1</div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <!--    <div class="font-weight-bold grey&#45;&#45;text mt-8 mb-2">-->
    <!--      TOMORROW  <span class="font-weight-regular">{{ $dayjs().add(1, 'day').format('L') }}</span>-->
    <!--    </div>-->

    <!--    <v-row-->
    <!--      no-gutters-->
    <!--    >-->
    <!--      <v-col style="flex: 0 0 30px">-->
    <!--        <v-avatar-->
    <!--          color="red"-->
    <!--          size="10px"-->
    <!--          class="mt-n3"-->
    <!--        />-->
    <!--      </v-col>-->
    <!--      <v-col class="white&#45;&#45;text body-1">-->
    <!--        <div-->
    <!--          style="opacity: 0.6"-->
    <!--          class="mb-1"-->
    <!--        >-->
    <!--          09:00 - 11:00-->
    <!--        </div>-->
    <!--        <div>Training at Field #1</div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <!--    <v-row-->
    <!--      no-gutters-->
    <!--      class="mt-3"-->
    <!--    >-->
    <!--      <v-col style="flex: 0 0 30px">-->
    <!--        <v-avatar-->
    <!--          color="orange"-->
    <!--          size="10px"-->
    <!--          class="mt-n3"-->
    <!--        />-->
    <!--      </v-col>-->
    <!--      <v-col class="white&#45;&#45;text body-1">-->
    <!--        <div-->
    <!--          style="opacity: 0.6"-->
    <!--          class="mb-1"-->
    <!--        >-->
    <!--          12:00 - 14:00-->
    <!--        </div>-->
    <!--        <div>Testing session at Field #1</div>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
  </div>
</template>

<script>

import dayjs from 'dayjs'
import { EventApiService } from '@/data/services'
import { EventTypes } from '@/data/models'
import { EventBus } from '@/plugins/bus'

export default {
  name: 'CalendarSidebar',
  props: {
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    events: {
      loading: false,
      data: []
    },
    days: [],
    upcoming: []
  }),
  computed: {
    dayjs() {
      return dayjs
    }
  },
  created() {
    this.upcoming = Array.from({ length: 7 }, (_, i) => {
      return {
        date: dayjs().add(i, 'day').format('YYYY-MM-DD'),
        events: []
      }
    })

    this.$nextTick(() => {
      this.fetchEvents()
    })

    this.eventTypes = EventTypes
  },
  mounted() {
    EventBus.$on([this.$events.EVENT_CREATED, this.$events.EVENT_UPDATED], (event) => {
      this.fetchEvents()
    })
  },
  methods: {
    async fetchEvents() {
      this.events.loading = true

      try {
        const response = await EventApiService.getAll({
          from: dayjs().format('YYYY-MM-DD'),
          to: dayjs().add(7, 'day').format('YYYY-MM-DD'),
          order_by: 'start_at',
          compact: true
        })

        const events = response.data

        this.events.data = events

        this.upcoming = this.upcoming.map(day => {
          return {
            ...day,
            events: events.filter(e => {
              return dayjs(e.start_at).isSame(day.date, 'date')
            })
          }
        })
      } catch (e) {

      } finally {
        this.events.loading = false
      }
    }
  }
}
</script>
